import { defineMessages } from 'react-intl';

export default defineMessages({
  commissionRules: {
    id: 'app.modules.datSheet.mainPage.commissionRules',
    defaultMessage: 'Commission Rules',
  },
  daySheets: {
    id: 'app.modules.datSheet.mainPage.daySheets',
    defaultMessage: 'Day Sheets',
  },
});
